(() => {
  if (customElements.get('isacco-stock-gate')) return;
  class IsaccoStockGate extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent); }
      catch { this.variants = {}; }
      this.scope = this.closest('product-form') || this.parentElement;
      this.refresh = () => this.apply();
      this.onSubmit = event => { if (!this.apply()) { event.preventDefault(); event.stopImmediatePropagation(); } };
      this.scope.addEventListener('change', this.refresh, true);
      this.scope.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(() => {
        if (this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => { this.scheduled = false; if (this.isConnected) this.apply(); });
      });
      this.observer.observe(this.scope, {subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled']});
      this.timer = setInterval(this.refresh, 15000);
      this.apply();
    }
    disconnectedCallback() {
      clearInterval(this.timer); this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.refresh, true);
      this.scope?.removeEventListener('submit', this.onSubmit, true);
    }
    apply() {
      const form = document.getElementById(this.dataset.formId);
      const id = form?.querySelector('[name="id"]')?.value;
      const state = this.variants?.[id];
      // Same conservative five-minute margin as the checkout lease. This is UI
      // guidance only; Shopify independently enforces its own checkout clock.
      const allowed = state?.approved === true && state?.available === true
        && Number.isFinite(Date.parse(state.expiresAt)) && Date.parse(state.expiresAt) > Date.now() + 300000;
      const locale = this.dataset.locale;
      const words = locale === 'it' ? {buy:'Aggiungi al carrello',ready:'Ordinabile',inquiry:'Disponibile solo su richiesta'}
        : locale === 'en' ? {buy:'Add to cart',ready:'Available to order',inquiry:'Available on request'}
        : {buy:'In den Warenkorb',ready:'Bestellbar',inquiry:'Nur auf Anfrage erhältlich'};
      const button = form?.querySelector('[name="add"]');
      if (button) {
        if (button.disabled !== !allowed) button.disabled = !allowed;
        const label = button.querySelector('span');
        const text = allowed ? words.buy : words.inquiry;
        if (label && label.textContent.trim() !== text) label.textContent = text;
      }
      const payment = form?.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !allowed;
      const status = this.querySelector('.isacco-stock-gate__status');
      if (status && status.textContent !== (allowed ? words.ready : words.inquiry)) status.textContent = allowed ? words.ready : words.inquiry;
      const inquiry = this.querySelector('.isacco-stock-gate__inquiry');
      if (inquiry) {
        inquiry.hidden = allowed;
        inquiry.href = this.dataset.contactUrl + '?product=' + encodeURIComponent(this.dataset.productTitle || '') + '&variant=' + encodeURIComponent(state?.variantTitle || '');
      }
      return allowed;
    }
  }
  customElements.define('isacco-stock-gate', IsaccoStockGate);
})();
